import { Link, useLocation } from 'react-router-dom';
import { useState } from 'react';
import { useAuth } from '@/lib/auth-context';
import { Menu, X } from 'lucide-react';

export default function Navbar() {
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);
  const isDashboard = location.pathname.startsWith('/dashboard');
  if (isDashboard) return null;

  const navLinks = [
    { to: '/features', label: 'Features' },
    { to: '/pricing', label: 'Pricing' },
    { to: '/docs', label: 'Docs' },
    { to: '/blog', label: 'Blog' },
  ];

  return (
    <nav data-testid="navbar" className="fixed top-0 left-0 right-0 z-50 glass">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" data-testid="navbar-logo" className="flex items-center gap-2 group">
            <span className="text-emerald-500 font-mono font-bold text-xl tracking-tight">
              <span className="text-cyan-400">{'>'}</span>_ClawStinger
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map(l => (
              <Link
                key={l.to}
                to={l.to}
                data-testid={`nav-${l.label.toLowerCase()}`}
                className={`text-sm font-mono transition-colors ${location.pathname === l.to ? 'text-emerald-400' : 'text-zinc-400 hover:text-white'}`}
              >
                {l.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-4">
            {isAuthenticated ? (
              <Link to="/dashboard" data-testid="nav-dashboard-btn" className="bg-emerald-500 text-black font-mono font-bold text-sm rounded-sm px-5 py-2 hover:bg-emerald-400 transition-all click-scale">
                Dashboard
              </Link>
            ) : (
              <>
                <Link to="/signin" data-testid="nav-signin-btn" className="text-sm font-mono text-zinc-400 hover:text-white transition-colors">
                  Sign In
                </Link>
                <Link to="/signup" data-testid="nav-signup-btn" className="bg-emerald-500 text-black font-mono font-bold text-sm rounded-sm px-5 py-2 hover:bg-emerald-400 transition-all click-scale shadow-[0_0_15px_rgba(16,185,129,0.3)]">
                  Start Free Trial
                </Link>
              </>
            )}
          </div>

          <button
            data-testid="mobile-menu-btn"
            className="md:hidden text-zinc-400 hover:text-white"
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            {mobileOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-[#0A0A0A] border-t border-zinc-800 px-4 py-4 space-y-3 animate-fade-in">
          {navLinks.map(l => (
            <Link key={l.to} to={l.to} onClick={() => setMobileOpen(false)} className="block text-sm font-mono text-zinc-400 hover:text-white py-2">
              {l.label}
            </Link>
          ))}
          <div className="pt-3 border-t border-zinc-800 flex flex-col gap-2">
            {isAuthenticated ? (
              <Link to="/dashboard" onClick={() => setMobileOpen(false)} className="bg-emerald-500 text-black font-mono font-bold text-sm rounded-sm px-5 py-2 text-center">Dashboard</Link>
            ) : (
              <>
                <Link to="/signin" onClick={() => setMobileOpen(false)} className="text-sm font-mono text-zinc-400 text-center py-2">Sign In</Link>
                <Link to="/signup" onClick={() => setMobileOpen(false)} className="bg-emerald-500 text-black font-mono font-bold text-sm rounded-sm px-5 py-2 text-center">Start Free Trial</Link>
              </>
            )}
          </div>
        </div>
      )}
    </nav>
  );
}
